import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../Assets/Css/WaterJugView.scss';
import moment from 'moment/moment';

const WaterJugView = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const waterJug = location?.state?.data?.allData;

    return (
        <div className='waterJugView-main'>
            <div className="page-title">
                <h4> Water Jug </h4>
                <div className="edit-btn">
                    <button
                        type="button"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>
                </div>
            </div>

            {/* Content Section */}
            <div className='content-part'>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="waterJug-detail">
                                    <h5 className='waterJugView-detail-divider'> Water Jug Details </h5>
                                    <div className='row'>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Date</h6>
                                            </div>
                                            <div className='col-9'>
                                                <h6 className='labels'>
                                                    {waterJug?.today_date ? moment(waterJug.today_date).format("DD-MM-YYYY") : 'N/A'}
                                                </h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>No. of Jugs</h6>
                                            </div>
                                            <div className='col-9'>
                                                <h6 className='labels'>
                                                    {waterJug?.no_of_jug || '0'}
                                                </h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WaterJugView;
